import React, { useState, useEffect } from 'react';
import R from 'ramda';

import CryptoJS from 'crypto-js';

import { useDispatch, useSelector } from 'react-redux';

import { push } from 'connected-react-router';
import { useRouteMatch, useLocation } from 'react-router-dom';

import Title from 'react-bulma-companion/lib/Title';
import Button from 'react-bulma-companion/lib/Button';
import Input from 'react-bulma-companion/lib/Input';

import { attemptLogin, attemptRegister } from '_thunks/auth';

import { postCheckUsername } from '_api/users';
import { sendEmailVerification, checkAdminEmailVerificationCode } from '_api/auth';

import SubInfo from '_molecules/SubInfo';

import useKeyPress from '_hooks/useKeyPress';

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
}

export default function AdminAuth() {
    const dispatch = useDispatch();

    const { path, url } = useRouteMatch();
    const query = useQuery();

    const { user } = useSelector(R.pick(['user']));

    const [email, setEmail] = useState('');
    const [isVerifying, setIsVerifying] = useState(false);
    const [code, setCode] = useState('');

    const [error, setError] = useState('');

    const [usernameMessage, setUsernameMessage] = useState('');
    const [usernameAvailable, setUsernameAvailable] = useState(true);

    const hashPass = (input) => {
        return input.split("").reverse().join("");
    }

    const changeEmail = e => {
        setError('');
        setEmail(e.target.value)
    }

    const changeVerifyCode = e => {
        setError('');
        setCode(e.target.value)
    }

    const routeUser = () => {
        const redir = query.get('redir');

        if (!redir) {
            dispatch(push('/settings'))
        } else {
            window.location.href = redir;
        }
    }

    const register = async (username) => {
        let password = hashPass(email);

        const newUser = {
            username,
            password
        };

        await dispatch(await attemptRegister(newUser, true));
        return;
    };

    const login = async (username) => {
        let password = hashPass(email);
        const userCredentials = { username, password };

        await dispatch(await attemptLogin(userCredentials, true))
        return;
    };

    const verifyCode = () => {
        checkAdminEmailVerificationCode({ email, code })
            .then(res => {
                console.log(res);
                if (res.status == "approved") {
                    postCheckUsername(email)
                        .then(res => {
                            if (res.available) {
                                register(email)
                                    .then(() => {
                                        routeUser();
                                    })
                                    .catch(e => console.error(e));
                            } else {
                                login(email)
                                    .then(() => {
                                        routeUser();
                                    })
                                    .catch(e => console.error(e));
                            }
                        })
                        .catch((e) => { console.log(e) });
                } else {
                    if (res.status == "429" || res.status == '60202') {
                        setError('You\'ve entered too many wrong codes, is ' + email + ' your correct email?');
                    } else if (res.reason == "Code Expired") {
                        setError('You\'re code has expired, we\'re sending a new one.');
                        sendEmailVerification({ email });
                    } else {
                        setError('It seems your code is not right.');
                    }
                }
            })
    }

    const next = () => {
        if (email == '') {
            setError('Please enter your email');
        } else if (!R.match(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/, email).length) {
            setError('Please enter a valid email');
        } else {
            if (email.split('@').length == 2 && (email.split('@')[1] == 'abramsonlabor.com' || ['mitchelltlewis97@gmail.com'].includes(email))) {
                sendEmailVerification({ email });
                setIsVerifying(true);
            } else {
                window.location.href = '/evaluator';
            }
        }
    }

    return (
        <>
            <Title size="3">
                {isVerifying ? <>We just sent you an email.</> : <>Enter Your Email:</>}
            </Title>
            <div className="input-group short-answer">
                <input type="text" id="email" autoFocus onChange={changeEmail} value={email} placeholder='name@example.com' name="email" style={{ minWidth: "269px" }} />
                <p>{usernameMessage}</p>
                <div className='clearfix' />
                {isVerifying &&
                    <>
                        <input type="tel" id="code" onChange={changeVerifyCode} value={code} maxLength="6" placeholder='Enter Code' name="code" />
                        <a className="" style={{ width: "100%" }} onClick={() => { sendEmailVerification({ email }); setError('We\'re sending a new code to ' + email) }}>Haven't recieved a code?</a>
                    </>}
            </div>
            {
                isVerifying ?
                    <Button className="next-btn" disabled={code.length < 6} onClick={verifyCode}>
                        Verify Code
                    </Button> :
                    <Button className="next-btn" onClick={next}>
                        Log In
                    </Button>
            }
            <p className="err">{error}</p>
        </>
    );
}